import { useEffect, useState } from 'react';
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';

export function useMsalInitialization(pca: PublicClientApplication) {
  const [initialized, setInitialized] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [authResult, setAuthResult] = useState<AuthenticationResult | null>(null);

  useEffect(() => {
    pca
      .initialize()
      .then(() => pca.handleRedirectPromise())
      .then((result) => {
        setAuthResult(result);
        setInitialized(true);
      })
      .catch((err: Error) => {
        setError(err);
      });
  }, [pca]);

  return { initialized, error, authResult };
}
